const BASE = (import.meta.env.VITE_API_URL ?? '') + '/api/public/events'

function getSessionId(): string {
  const key = 'lm-session-id'
  let id = sessionStorage.getItem(key)
  if (!id) {
    id = `${Date.now()}-${Math.random().toString(36).slice(2)}`
    sessionStorage.setItem(key, id)
  }
  return id
}

function track(
  event_type: string,
  extras?: { model_id?: number | null; option_id?: number | null; metadata?: Record<string, unknown> }
): void {
  const payload = {
    session_id: getSessionId(),
    event_type,
    model_id: extras?.model_id ?? null,
    option_id: extras?.option_id ?? null,
    metadata: extras?.metadata,
  }
  // fire-and-forget — never throws, never awaited
  fetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {/* swallow */})
}

export const trackSessionStart = () => track('session_start')
export const trackModelSelected = (model_id: number) => track('model_selected', { model_id })
export const trackOptionToggled = (option_id: number, model_id: number, selected: boolean) =>
  track('option_toggled', { option_id, model_id, metadata: { selected } })
export const trackStepViewed = (step: string, model_id?: number) =>
  track('step_viewed', { model_id, metadata: { step } })
export const trackReviewViewed = (model_id: number) => track('review_viewed', { model_id })
export const trackFormStarted = (model_id: number) => track('form_started', { model_id })
export const trackLeadSubmitted = (model_id: number, lead_id: number, total: number) =>
  track('lead_submitted', { model_id, metadata: { lead_id, total } })
